/* Timezone list : https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */

import {
  useLocalization,
  useLocalizationContext,
} from '@im/react-localization';
import { useSearchParams } from 'react-router-dom';
import {
  cultureCodeTimeZoneMapping,
  cultureCodeDateFormatterMapping,
  LOCALE_SUPPORTED,
  useBuildVars,
} from 'src/config';

export const useGetDateFormat = () => {
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode') ?? '';
  const { locale } = useLocalizationContext();

  const locales = LOCALE_SUPPORTED.some((l) => l.includes(countryCode))
    ? locale
    : `en-${countryCode}`;

  return (
    cultureCodeDateFormatterMapping[
      locales as keyof typeof cultureCodeDateFormatterMapping
    ] ??
    cultureCodeDateFormatterMapping[
      locale as keyof typeof cultureCodeDateFormatterMapping
    ]
  );
};

export const useDateTimeFormatter = () => {
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode') ?? '';
  const { formatDate } = useLocalization();
  const { locale } = useLocalizationContext();
  const { buildEnvironment } = useBuildVars();
  const dateFormat = useGetDateFormat();

  const locales = LOCALE_SUPPORTED.some((l) => l.includes(countryCode))
    ? locale
    : `en-${countryCode}`;

  return (date: string | Date, isTimeRequired?: boolean) => {
    const formattedDate = formatDate(date, dateFormat);

    if (isTimeRequired) {
      const zone =
        cultureCodeTimeZoneMapping[
          locales as keyof typeof cultureCodeTimeZoneMapping
        ];
      const timeZone =
        zone ??
        cultureCodeTimeZoneMapping[
          locale as keyof typeof cultureCodeTimeZoneMapping
        ];
      if (
        buildEnvironment === 'development' ||
        buildEnvironment === 'staging'
      ) {
        // eslint-disable-next-line no-console
        console.log('timeZone', timeZone);
      }
      const localesArgument = zone ? locales : locale;
      const formattedDateTime = new Date(date).toLocaleString(localesArgument, {
        timeZone: timeZone,
      });
      return `${formattedDate},${formattedDateTime.split(',')[1]}`;
    }

    return formattedDate;
  };
};
